import { QOverlay } from "@qamf/lighthouse";
import { onClickOutside } from "@vueuse/core";
import { defineComponent, onBeforeMount, PropType, ref, useTemplateRef } from "vue";

export default defineComponent({
	name: "ReservationFormBase",
	components: {
		QOverlay,
	},
	props: {
		compact: { type: Boolean, default: false },
		customClass: { type: String, default: "" },
		responsiveAt: {
			type: String as PropType<"sm" | "md" | "lg" | "xl">,
			default: "sm"
		}
	},
	emits: ["onSubmit"],
	setup(props, { emit }) {
		const reservationForm = useTemplateRef<HTMLDivElement | null>("reservationForm");
		const classesObj = ref<object>({});
		const isOverlayVisible = ref(false);

		const setClasses = () => {
			const isCompactValue = props.compact;
			classesObj.value = {
				compact: isCompactValue,
				full: !isCompactValue
			};
		};
		const hideOverlay = () => {
			isOverlayVisible.value = false;
		};
		const showOverlay = () => {
			isOverlayVisible.value = true;
		};
		onClickOutside(reservationForm, () => hideOverlay());

		const submit= () => {
			emit("onSubmit");
		};

		onBeforeMount(() => {
			setClasses();
		});

		return {
			reservationForm,
			classesObj,
			isOverlayVisible,
			hideOverlay,
			showOverlay,
			submit
		};
	}});
